export function isHybrisApiCallWithSession(url: string): boolean {
  return [ '/occ-cms' ].some((hybrisUrl: string) => url.includes(hybrisUrl));
}
